import { withStyles } from '@material-ui/styles';
import clsx from 'clsx';
import { flowRight } from 'lodash';
import React, { useState } from 'react';
import { injectIntl } from 'react-intl';

import styles from '../styles/customTitle';
import { isBoolean } from '../../../utils/isDefined';

function CustomTitle({
  intl,
  title,
  children,
  classes,
  isDataExist = false,
  isDefaultOpen = false,
  dotsMenu = false,
  menuComponent = null,
  directTitle = null,
  isOpen,
  onToggle
}) {
  const [open, setOpen] = useState(isDefaultOpen);
  const expanded = isBoolean(isOpen) ? isOpen : open;

  const toggle = value => {
    if (!isDataExist) return;

    if (onToggle) {
      onToggle(value);
    } else {
      setOpen(value);
    }
  };

  return (
    <div className={classes.root}>
      <div className={classes.title}>
        <div
          className={classes.labelContainer}
          onClick={() => toggle(!expanded)}
          style={{ cursor: isDataExist ? 'pointer' : 'unset' }}
        >
          {expanded ? (
            <i
              className={clsx('fas fa-chevron-down', classes.icon, {
                [classes.hidden]: !isDataExist
              })}
              onClick={() => toggle(false)}
            />
          ) : (
            <i
              className={clsx('fas fa-chevron-right', classes.icon, {
                [classes.hidden]: !isDataExist
              })}
              onClick={() => toggle(true)}
            />
          )}
          <div className={classes.label}>
            {directTitle ? directTitle : intl.formatMessage({ id: title })}
          </div>
        </div>
        {isDataExist && dotsMenu && menuComponent}
      </div>
      <div
        className={clsx(classes.content, {
          [classes.contentVisible]: expanded
        })}
      >
        {expanded && children}
      </div>
    </div>
  );
}

export default flowRight(injectIntl, withStyles(styles))(CustomTitle);
